import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import PageHero from '@/components/feature/PageHero';
import Reveal from '@/components/base/Reveal';
import EpinScanDemo from '@/pages/epin/components/EpinScanDemo';
import EpinFullFlow from '@/pages/epin/components/EpinFullFlow';
import EpinRoles from '@/pages/epin/components/EpinRoles';
import EpinRoleDetails from '@/pages/epin/components/EpinRoleDetails';
import EpinPermissions from '@/pages/epin/components/EpinPermissions';
import { epinHero, epinIntro, epinStats } from '@/mocks/epin';

export default function Epin() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="ePin食安码｜一物一码全链路食安溯源｜华辉数智"
        description="ePin食安码为农产品赋予唯一数字身份，覆盖生产建档、质检赋码、仓储物流、商品上架到消费者扫码的全链路溯源，支持异常冻结、召回与分账追溯。"
        keywords="ePin食安码,食品安全溯源,一物一码,农产品溯源,食安码,全链路追溯"
        path="/cases/epin-food-safety"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: 'ePin食安码：一物一码全链路食安溯源',
          description:
            'ePin食安码覆盖九大角色协同与八步全程溯源流程，实现从生产建档到消费者扫码的全链路食品安全溯源。',
          articleSection: '客户案例',
        }}
      />

      <PageHero
        eyebrow={epinHero.eyebrow}
        title={epinHero.title}
        titleHighlight={epinHero.titleHighlight}
        subtitle={epinHero.subtitle}
        desc={epinHero.desc}
        imageUrl={epinHero.imageUrl}
        imageAlt="ePin食安码一物一码全链路食安溯源"
        imageTitle="ePin食安码"
      />

      <Breadcrumb
        items={[{ label: '客户案例', href: '/cases' }, { label: 'ePin食安码' }]}
      />

      <main>
        {/* 概述 + 数据 */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-8 lg:gap-14 items-center">
            <Reveal>
              <div>
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold tracking-wide whitespace-nowrap">
                  <i className="ri-qr-code-line"></i>
                  产品概述
                </span>
                <h2 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
                  {epinIntro.title}
                </h2>
                <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                  {epinIntro.desc}
                </p>
              </div>
            </Reveal>
            <Reveal>
              <div className="grid grid-cols-2 gap-4">
                {epinStats.map((s) => (
                  <div key={s.label} className="p-5 rounded-lg bg-background-100 border border-background-200">
                    <div className="flex items-baseline gap-1">
                      <span className="font-heading font-bold text-2xl md:text-3xl text-primary-600">
                        {s.value}
                      </span>
                      <span className="text-sm text-foreground-500">{s.unit}</span>
                    </div>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{s.label}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </section>

        <EpinScanDemo />
        <EpinRoles />
        <EpinRoleDetails />
        <EpinFullFlow />
        <EpinPermissions />
      </main>

      <Footer />
    </div>
  );
}